var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.isErp === 1 && _vm.item.appCode === 'cloud_business') || _vm.isErp === 0)?_c('div',{class:_vm.classes,on:{"click":_vm.onToPath}},[_c('span',{staticClass:"vi-sidebar-sub-item--text"},[_vm._v(_vm._s(_vm.item.reMenu))]),_vm._v(" "),_c('span',{staticClass:"vi-sidebar-sub-item--tar"},[(_vm.appLoading)?_c('i',{staticClass:"el-icon-loading",staticStyle:{"color":"#C8CCD5","top":"2px"}}):_c('i',{staticClass:"el-icon-caret-right"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/sidebarSubItem.vue